import CollapsiblePanel from "./component";
export default CollapsiblePanel;